import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CargomaticCard from 'components/v2/card';
import ReferenceNumbersList from 'components/ui/tailwind/ReferenceNumber';
import EditButton from 'components/v2/buttons/EditButton';
import { sortBy } from 'lodash';
import { titleize } from 'underscore.string';
const ReferenceNumbers = (props) => {
    const order = props.order;
    if (!order) {
        return null;
    }
    const reference_numbers = (order.reference_numbers || []).filter((o) => !o.hidden);
    const firstSorted = sortBy(reference_numbers, (ref) => ref.name.toLowerCase().includes('master')).reverse();
    const sorted = sortBy(firstSorted, (ref) => ref.name.toLowerCase().includes('order'));
    const { t } = useTranslation();
    return (React.createElement(CargomaticCard, { header: () => (React.createElement("div", { className: "flex flex-wrap justify-between items-center" },
            React.createElement("h3", { className: "my-0" }, titleize(t('REFERENCE_NUMBERS'))),
            React.createElement(EditButton, { onClick: props.onEdit }))) },
        React.createElement(ReferenceNumbersList, { reference_numbers: sorted })));
};
ReferenceNumbers.propTypes = {
    order: PropTypes.shape({
        reference_numbers: PropTypes.array,
    }).isRequired,
    onEdit: PropTypes.func.isRequired,
};
export default ReferenceNumbers;
